import { kebabCase } from 'lodash-es';
import RecipeWishlistItem from './recipe-wishlist-item';
import { type RecipesWishlistResult } from '~/types/queriesResponse/getRecipesWishlistsResponse';

export default class RecipeWishlist {
  name: string;
  slug: string;
  id: string;
  version: number;
  createdAd: string;
  items: RecipeWishlistItem[];

  constructor(name: string, slug: string, id: string, version: number, createdAt: string, items: RecipeWishlistItem[]) {
    this.name = name;
    this.slug = slug;
    this.id = id;
    this.version = version;
    this.createdAd = createdAt;
    this.items = items;
  }

  static fromQueryResult(query: RecipesWishlistResult): RecipeWishlist {
    const timestamp = new Date(query.createdAt).getTime();
    return new RecipeWishlist(
      query.name,
      kebabCase(`${timestamp}-${query.name}`),
      query.id,
      query.version,
      query.createdAt,
      query.textLineItems.map((item) => RecipeWishlistItem.fromTextLineItem(item)),
    );
  }
}
